import { useAuthenticator } from '@aws-amplify/ui-react';

export function useAuthType() {
  const { user } = useAuthenticator();
  const type = user.signInDetails?.authFlowType;

  return type;
}
